module.exports = "/assets/data/c3de6d0308aaa35f08deb0bbf6f66a44-G69.data.json";